import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { findWorkflowStep, getWorkflowMoveByID } from "@/api/workflowProcess.js";
export default {
  name: "WorklowUse",
  data: function data() {
    return {
      done: false,
      business: null,
      node: null,
      moves: [],
      move: null
    };
  },
  computed: {
    processStatus: function processStatus() {
      var node = this.moves[this.moves.length - 1];
      if (node && node.workflowNode.clazz == "end") {
        if (node.workflowNode.success) {
          return "success";
        } else {
          return "error";
        }
      } else {
        return "process";
      }
    }
  },
  methods: {
    createDone: function createDone() {
      var path = "";
      if (this.node.view) {
        path = this.node.view;
      } else {
        path = this.workflow.view;
      }
      this.$options.components.WorkflowInfo = function () {
        return import("@/" + path);
      };
      this.done = true;
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var workflowId, workflowMoveID, res, _res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            workflowId = _this.$route.query.workflowId;
            workflowMoveID = _this.$route.query.workflowMoveID;
            if (!workflowId) {
              _context.next = 9;
              break;
            }
            _context.next = 5;
            return findWorkflowStep({
              id: workflowId
            });
          case 5:
            res = _context.sent;
            if (res.code == 0) {
              _this.workflow = res.data.workflow;
              _this.node = res.data.workflow.nodes[0];
              _this.createDone();
            }
            _context.next = 14;
            break;
          case 9:
            if (!workflowMoveID) {
              _context.next = 14;
              break;
            }
            _context.next = 12;
            return getWorkflowMoveByID({
              id: workflowMoveID
            });
          case 12:
            _res = _context.sent;
            if (_res.code == 0) {
              _this.business = _res.data.business;
              _this.workflow = _res.data.move.workflowProcess;
              _this.node = _res.data.move.workflowNode;
              _this.move = _res.data.move;
              _this.moves = _res.data.moves;
              _this.createDone();
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeCreate: function beforeCreate() {}
};